import { VerificationLayout } from "@/components/seller/verification/VerificationLayout";
import { CookProfileForm } from "@/components/seller/verification/CookProfileForm";

const CookProfileVerification = () => {
  return (
    <VerificationLayout currentStep={1} totalSteps={3}>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight text-primary">Create Your Chef Profile</h2>
          <p className="text-foreground">
            Tell us about yourself and your cooking expertise. This information will be visible to customers.
          </p>
        </div>

        <CookProfileForm />
      </div>
    </VerificationLayout>
  );
};

export default CookProfileVerification;